import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatComponentsModule } from "../../mat-components.module";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgGridModule } from "ag-grid-angular";
import { AdminLayoutRoutingModule } from "./admin-layout.routing.module";
import { DashboardModule } from "../dashboard/dashbaord.module";
import { AdminLayoutComponent } from "./admin-layout.component";
import { UserManagementComponent } from "./user-management/user-management.component";
import { CreateModalComponent } from "./user-management//create-modal/create-modal.component";
import { ChartsModule } from "../shared/charts/charts.module";

@NgModule({
  declarations: [
    AdminLayoutComponent,
    UserManagementComponent,
    CreateModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AdminLayoutRoutingModule,
    AgGridModule,
    ReactiveFormsModule,
    MatComponentsModule,
    DashboardModule,
    ChartsModule
  ],
  exports: [
    AdminLayoutComponent,
    UserManagementComponent,
    CreateModalComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AdminLayoutModule {}
